
export function getAccessType() {
    try {
        const val = JSON.parse(localStorage.getItem("data"))?.accessType;
        return ["ONLY_FIXED_GPS", "ONLY_DIGITAL_LOCK", "BOTH"].includes(val) ? val : "BOTH";
    } catch {
        return "BOTH";
    }
}
export function canAccessFixedGPS(accessType) {
    return accessType === "ONLY_FIXED_GPS" || accessType === "BOTH";
}

export function canAccessDigitalLock(accessType) {
    return accessType === "ONLY_DIGITAL_LOCK" || accessType === "BOTH";
}

export function canAccessDriverDashboard(accessType) {
    return accessType === "ONLY_DIGITAL_LOCK" || accessType === "ONLY_FIXED_GPS" || accessType === "BOTH";
}

export function getAvailableModes(accessType) {
    const modes = [];
    if (canAccessFixedGPS(accessType)) modes.push("gps");
    if (canAccessDigitalLock(accessType)) modes.push("digitalLock");
    if (canAccessDriverDashboard(accessType)) modes.push("driver");
    return modes;
}